import React, { useState } from "react";
import NoFooterModal from "../Common/NoFooterModal";
import { Box, Button } from "@mui/material";
import { Typography } from "@material-ui/core";
import useMutation from "../../hooks/useMutation";
import CommunicationHubApis from "../../services/api/CommunicationHub";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStatus } from "../../store/actions/User";
import { pathMappings } from "./constants";

const DeleteAssignmentDialog = ({ selectedRows = [], callback }) => {
  const { tag, id } = useParams();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const dispatch = useDispatch();
  const { mutate: deleteAssignment, isPending } = useMutation(
    CommunicationHubApis.deleteAssignment
  );

  const handleDelete = async () => {
    try {
      await deleteAssignment({
        element_type: pathMappings[tag],
        element_id: id,
        mapping_ids: selectedRows,
      });
      callback && callback();
      handleClose();
    } catch (err) {
      console.log(err);
      dispatch(
        setStatus({
          message: "Something went wrong",
          type: "error",
        })
      );
    }
  };
  return (
    <>
      <Button
        onClick={handleOpen}
        color="error"
        variant="outlined"
        disabled={selectedRows.length === 0}
      >
        Unassign
      </Button>
      {open && (
        <NoFooterModal
          handleClose={handleClose}
          header
          heading="Confirm unassign"
        >
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography>
              Are you sure you want to unassign for the selected{" "}
              {selectedRows.length} entries?
            </Typography>
          </Box>
          <Box mt={4} display={"flex"} justifyContent={"end"} gap={2}>
            <Button
              onClick={handleClose}
              className="sushi-btn"
              color="error"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              className="sushi-btn"
              color="error"
              variant="contained"
              disabled={isPending}
            >
              Confirm
            </Button>
          </Box>
        </NoFooterModal>
      )}
    </>
  );
};

export default DeleteAssignmentDialog;
